export default ({...props}) => (
    <svg className="svg-node" {...props}>
        <g transform="translate(0.5,0.5)" style={{visibility: "visible"}}>
            {/*<ellipse cx="15.84" cy="14.88" rx="14.399999999999999" ry="9.6" fill="#ffffff" stroke="#000000" stroke-width="1.3" pointer-events="all"></ellipse>*/}
            <rect rx="10" id="svg_1" height="20" width="30" y="5" x="0" fill="rgb(248, 206, 204)" stroke="rgb(184, 84, 80)" stroke-width="1.3" pointer-events="all"/>
            <text text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="10" id="svg_2" y="18" x="4" fill-opacity="null" stroke-opacity="null" stroke-width="0" stroke="#000" fill="#000000">开始</text>
        </g>
    </svg>
)
